// import { nanoid } from "nanoid"
// import { getObject } from "../utils/useful"

const formBuilderGroups = {
    'main': { key: 'main', title: '{{lang}}Mains inputs' },
    'advanced': { key: 'advanced', title: '{{lang}}Advanced inputs' },
    // 'flowControl': { key: 'flowControl', title: '{{lang}}Flow Controls' },
}


const TypeToInputType = {

    string: 'TextInput',
    number: 'NumberInput',
    date: 'DateInput',
    object: 'ObjectInput',
    stage: 'StageInput',
    record: 'ObjectInput',
    field: 'FieldInput',
    select: 'SelectInput',
    image: 'ImageInput',
    file: 'FileInput',


}

const InputTypeToType = {

    TextInput: 'string',
    NumberInput: 'number',
    DateInput: 'date',
    ObjectInput: 'object',
    StageInput: 'stage',
    recordInput: 'record',
    FieldInput: 'field',
    SelectInput: 'select',
    ImageInput: 'image',
    FileInput: 'file',

}


const FormBuilderObjects = {


    FieldInput: {
        label: '{{lang}}Field',
        type: 'FieldInput',
        icon: '/assets/icons/applets/database/field.svg',
        parent: 'main',
        sortType: 'text',
        value: ["A", "Z"],
        operators: [

        ],

        headers: [

        ],
        used: ['quiz', 'survey']


    },


    ObjectInput: {
        label: '{{lang}}Object',
        type: 'ObjectInput',
        icon: '/assets/icons/applets/database/form.svg',
        parent: 'main',
        sortType: 'text',
        value: ["A", "Z"],
        operators: [

        ],

        headers: [

        ],
        used: ['quiz', 'survey']


    },


    TextInput: {
        label: '{{lang}}Text',
        type: 'TextInput',
        icon: '/assets/icons/applets/database/text.svg',
        parent: 'main',
        sortType: 'text',
        value: ["A", "Z"],
        operators: [
            { title: "{{lang}}contains", value: "contains", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "{{lang}}not contains", value: "not contains", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "{{lang}}is", value: "==", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "{{lang}}is not", value: "is not", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "{{lang}}is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "{{lang}}is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Text' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Placeholder', defaultValue: '{{lang}}Text Input' } },
            { type: 'TextInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },


        ],
        used: ['quiz', 'survey']


    },



    TextAreaInput: {
        label: '{{lang}}Long text',
        type: 'TextAreaInput',
        icon: '/assets/icons/applets/database/longtext.svg',
        parent: 'main',
        sortType: 'text',
        operators: [
            { title: "contains", value: "contains", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "not contains", value: "not contains", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "is", value: "==", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "is not", value: "is not", valueInput: { type: 'TextInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Long text' } },
            { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}Long text' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } }
        ]
    },




    NumberInput: {
        label: '{{lang}}Number',
        type: 'NumberInput',
        icon: '/assets/icons/applets/database/number.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "=", value: "=", valueInput: { type: 'NumberInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "!=", value: "!=", valueInput: { type: 'NumberInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "<", value: "<", valueInput: { type: 'NumberInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: ">", value: ">", valueInput: { type: 'NumberInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: ">=", value: ">=", valueInput: { type: 'NumberInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "<=", value: "<=", valueInput: { type: 'NumberInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Number' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '' } },
            { type: 'NumberInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz', 'survey']
    },



    PriceInput: {
        label: '{{lang}}Price',
        type: 'PriceInput',
        icon: '/assets/icons/applets/database/price.svg',
        parent: 'main',
        sortType: 'price',
        operators: [
            { title: "contains", value: "contains", valueInput: { type: 'PriceInput', col: 2, information: { required: true, placeholder: "Enter a price" } } },
            { title: "not contains", value: "not contains", valueInput: { type: 'PriceInput', col: 2, information: { required: true, placeholder: "Enter a price" } } },
            { title: "is", value: "==", valueInput: { type: 'PriceInput', col: 2, information: { required: true, placeholder: "Enter a price" } } },
            { title: "is not", value: "is not", valueInput: { type: 'PriceInput', col: 2, information: { required: true, placeholder: "Enter a price" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Price' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '' } },
            { type: 'NumberInput', key: 'price', information: { label: '{{lang}}Price', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },



    DateInput: {
        label: '{{lang}}Date',
        type: 'DateInput',
        icon: '/assets/icons/applets/database/time.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "is", value: "==", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "is whithin", value: "is whithin", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "before", value: "before", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "after", value: "after", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "is on or before", value: "is on or before", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "is on or after", value: "is on or after", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "is not", value: "is not", valueInput: { type: 'DateInput', col: 2, information: { required: true, placeholder: "Enter a Date" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Date Picker' } },
            { type: 'DateInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            // { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
            // { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

        ]
    },


    DateTimeInput: {
        label: '{{lang}}Date time',
        type: 'DateTimeInput',
        icon: '/assets/icons/applets/database/time.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "is", value: "==", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "is whithin", value: "is whithin", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "before", value: "before", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "after", value: "after", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "is on or before", value: "is on or before", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "is on or after", value: "is on or after", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "is not", value: "is not", valueInput: { type: 'DateInput', col: 2, information: { required: true, canAddTime: true, showTime: false, showVariables: true, placeholder: "Enter a Date" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Date Picker' } },
            { type: 'DateInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            // { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
            // { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

        ]
    },


    TimeInput: {
        label: '{{lang}}Time',
        type: 'TimeInput',
        icon: '/assets/icons/applets/database/time.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "is", value: "==", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "is whithin", value: "is whithin", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "before", value: "before", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "after", value: "after", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "is on or before", value: "is on or before", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "is on or after", value: "is on or after", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "is not", value: "is not", valueInput: { type: 'TimeInput', col: 2, information: { required: true, placeholder: "Enter a Time" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Time Picker' } },
            { type: 'TimeInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '', seconds: true } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'seconds', information: { label: '{{lang}}With Second', defaultValue: false } },
            // { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
            // { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

        ]
    },








    SelectInput: {
        label: '{{lang}}Select',
        type: 'SelectInput',
        icon: '/assets/icons/applets/database/dropdown.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "is", value: "==", valueInput: { type: 'SelectInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is not", value: "is not", valueInput: { type: 'SelectInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is any of", value: "is any of", valueInput: { type: 'MultiSelectInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is none of", value: "is none of", valueInput: { type: 'MultiSelectInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Dropdown' } },
            // { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}Choose' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'MultipleChoiceInput', key: 'items', information: { label: '{{lang}}Options', inputClass: 'a', defaultValue: [] } },
            {
                type: 'MultiSelectInput', key: 'answers', information: { label: '{{lang}}Answers', inplaceEditable: true, type: 'local', items: [] },
                dependencies: [{
                    refKey: 'items',
                    targetKey: 'answers',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.items' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.items', value: '@data.items' },
                }],
            },
            { type: 'SwitchInput', key: 'hasColor', information: { label: '{{lang}}Has Color', defaultValue: false } },
            { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } }
        ],
        used: ['quiz', 'survey']
    },



    LookupInput: {
        label: '{{lang}}Lookup',
        type: 'LookupInput',
        icon: '/assets/icons/forms/subform.svg',
        parent: 'main',
        // sortType: "subform",
        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Lookup' } },
            // { type: 'SelectInput', key: 'collection', information: { label: '{{lang}}collection', address: 'getFrames', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, required: true } },
            { key: 'collection', secondKey: 'applet', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', mainParent: 'applet', mainParentTitle: 'name', parent: 'parents' }, type: 'api', placeholder: '{{lang}}collection', required: false }, },
            {
                key: 'field', type: 'SelectInput', col: '12', information: { label: '{{lang}}field', type: 'api', address: 'getFrameFields', filter: {}, fields: { title: 'information.label', value: 'key' }, fetchKey: 'fields', placeholder: '{{lang}}field', required: false }, showMain: false,
                dependencies: [{
                    refKey: 'collection',
                    targetKey: 'field',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.collection' }, operator: { value: '!=' }, target: { value: null } },
                                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeHeader: { key: 'information.filter._id', value: '@data.collection' },
                }],
            },

            // { type: 'SelectInput', key: 'field', information: { label: '{{lang}}field', address: 'getFrameFields', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, required: true } },
            // { type: 'SelectInput', key: 'field', information: { label: '{{lang}}field', address: 'getFrameFields', filter: {}, fields: { title: 'information.label', value: 'key' }, type: 'api' } },
            // { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: '' } },
            // { type: 'TextInput', key: 'defaultValue', information: { label: 'Default Value', defaultValue: [] } },

        ]
    },




    MultiSelectInput: {
        label: '{{lang}}Multiple select',
        type: 'MultiSelectInput',
        icon: '/assets/icons/applets/database/checklist.svg',
        parent: 'main',
        sortType: 'multiselect',
        operators: [
            { title: "has any of...", value: "has any of...", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "has all of...", value: "has all of...", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "is exactly", value: "is exactly", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "has none of...", value: "has none of...", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },

        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}MultiSelect' } },
            { type: 'OptionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}choose' } },
            { type: 'MultipleChoiceInput', key: 'items', information: { label: '{{lang}}Options', inputClass: 'a', defaultValue: [{ title: '{{lang}}Title', value: 0 }] } },
            { type: 'NumberInput', key: 'Min', information: { label: '{{lang}}Min-Limit', defaultValue: '' } },
            { type: 'NumberInput', key: 'Max', information: { label: '{{lang}}Max-Limit', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz']
    },


    ImageSelectInput: {
        label: '{{lang}}Image select',
        type: 'ImageSelectInput',
        icon: '/assets/icons/forms/imageselect.svg',
        parent: 'main',
        sortType: "propfileimagerow",
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'NumberInput', key: 'QUANTITY', information: { label: '{{lang}}QUANTITY', defaultValue: '1.00' } },
            { type: 'NumberInput', key: 'RATE', information: { label: '{{lang}}RATE', defaultValue: '0.00' } },
            { type: 'SelectInput', key: 'TAX', information: { label: '{{lang}}TAX', defaultValue: '{{lang}}Select Tax' } },
            { type: 'NumberInput', key: 'AMOUNT', information: { label: '{{lang}}AMOUNT', defaultValue: '0.00' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz', 'survey']
    },


    SwitchInput: {
        label: '{{lang}}Switch',
        type: 'SwitchInput',
        icon: '/assets/icons/forms/power.svg',
        parent: 'main',
        sortType: "check",
        operators: [
            { title: "is", value: "==", valueInput: { type: 'SwitchInput', col: 2, information: { defaultValue: false } } },
        ],
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Switch' } },
            { type: 'SwitchInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: true } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz']
    },

    CheckboxInput: {
        label: '{{lang}}Checkbox',
        type: 'CheckboxInput',
        icon: '/assets/icons/applets/database/chek.svg',
        parent: 'main',
        sortType: 'checkbox',
        operators: [
            { title: "contains", value: "contains", valueInput: { type: 'CheckboxInput', col: 2, information: { required: true } } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Long text' } },
            { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'checkbox' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } }
        ]
    },


    ImageInput: {
        label: '{{lang}}Image',
        type: 'ImageInput',
        icon: '/assets/icons/forms/image.svg',
        parent: 'main',
        sortType: "image",
        operators: [
            { title: "filenames contain...", value: "filenames contain...", valueInput: { type: 'ImageInput', col: 2, information: { required: true, placeholder: "Upload" } } },
            { title: "has file type...", value: "has file type...", valueInput: { type: 'ImageInput', col: 2, information: { required: true, placeholder: "Upload" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Image' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}Choose Image' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'NumberInput', key: 'Min', information: { label: '{{lang}}Min-size', defaultValue: '0' } },
            { type: 'NumberInput', key: 'Max', information: { label: '{{lang}}Max-size', defaultValue: '0' } },
            { type: 'SwitchInput', key: 'single', information: { label: '{{lang}}Single Image', defaultValue: false } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'copper', information: { label: '{{lang}}Use Cropper', defaultValue: true } },
            { type: 'TextInput', key: 'ratio', information: { label: '{{lang}}Cropper Ratio', defaultValue: '1:1' } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },


    // ImageInput: {
    //     label: '{{lang}}Image',
    //     type: 'ImageInput',
    //     icon: '/assets/icons/applets/database/image.svg',
    //     parent: 'main',
    //     sortType: 'image',
    //     operators: [
    //         { title: "between", value: "between", valueInput: { type: 'ImageInput', col: 2, information: { required: true, placeholder: "select an option" } } },
    //     ],

    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Dropdown' } },
    //         { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}choose' } },
    //         { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
    //         { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

    //     ],
    //     used: ['quiz']
    // },




    VideoInput: {
        label: '{{lang}}Video',
        type: 'VideoInput',
        icon: '/assets/icons/applets/database/image.svg',
        parent: 'main',
        sortType: 'video',
        operators: [
            { title: "between", value: "between", valueInput: { type: 'VideoInput', col: 2, information: { required: true, placeholder: "select an option" } } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Dropdown' } },
            // { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}choose' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz']
    },


    FileInput: {
        label: '{{lang}}File',
        type: 'FileInput',
        icon: '/assets/icons/forms/folder.svg',
        parent: 'main',
        sortType: "file",
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'TextInput', key: 'Min', information: { label: '{{lang}}Min-Size', defaultValue: '0' } },
            { type: 'TextInput', key: 'Max', information: { label: '{{lang}}Max-Size', defaultValue: '20' } },
            { type: 'TextInput', key: 'MinLimite', information: { label: '{{lang}}Min-Limit', defaultValue: 'N/A' } },
            { type: 'TextInput', key: 'MaxLimite', information: { label: '{{lang}}Max-Limit', defaultValue: '1' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz']
    },


    SliderInput: {
        label: '{{lang}}Slider',
        type: 'SliderInput',
        icon: '/assets/icons/applets/database/slidbar.svg',
        parent: 'main',
        sortType: 'Slider',
        operators: [
            { title: "between", value: "between", valueInput: { type: 'SliderInput', col: 2, information: { required: true, placeholder: "Enter a range" } } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}slider' } },
            { type: 'NumberInput', key: 'min', information: { label: '{{lang}}Min', defaultValue: 0 } },
            { type: 'NumberInput', key: 'max', information: { label: '{{lang}}Max', defaultValue: 100 } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },


    // TO DO
    LocalSelectInput: {
        label: '{{lang}}LocalSelect',
        type: 'LocalSelectInput',
        icon: '/assets/icons/forms/localselect.svg',
        parent: 'main',
        sortType: 'localselect',
        hideInFormBuilder: true,

        operators: [
            { title: "has any of...", value: "has any of...", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "has all of...", value: "has all of...", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "is exactly", value: "is exactly", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "has none of...", value: "has none of...", valueInput: { type: 'MultipleChoiceInput', col: 2, information: { required: true, placeholder: "select an option" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },

        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Dropdown' } },
            // { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}choose' } },
            // { type: 'MultipleChoiceInput', key: 'test', information: { label: '{{lang}}Holder', inputClass: 'a', defaultValue: [{ title: '{{lang}}Title', value: 0 }] } },
            { type: 'EditList', key: 'items', information: { label: '{{lang}}List', inputClass: 'a', items: [] } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            // { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        used: ['quiz']
    },


    MultiContentInput: {
        label: '{{lang}}Multi content',
        type: 'MultiContentInput',
        icon: '/assets/icons/applets/database/image.svg',
        parent: 'main',
        sortType: 'video',
        hideInFormBuilder: true,

        operators: [
            { title: "between", value: "between", valueInput: { type: 'VideoInput', col: 2, information: { required: true, placeholder: "select an option" } } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Dropdown' } },
            // { type: 'optionMakerInput', key: 'options', information: { label: '{{lang}}Options', options: [], type: 'radio' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}choose' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'searchable', information: { label: '{{lang}}Searchable', defaultValue: true } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ],
        // used: ['quiz']
    },


    // NumberInput3: {
    //     label: 'Number',
    //     type: 'NumberInput',
    //     icon: '/assets/icons/forms/number.png',
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: {required:true, label: 'Field Label', defaultValue: 'Number' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: '' } },
    //         { type: 'NumberInput', key: 'defaultValue', information: { label: 'Default Value', defaultValue: '' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },






    MapInput: {
        label: '{{lang}}Map',
        type: 'MapInput',
        icon: '/assets/icons/forms/map.svg',
        parent: 'advanced',
        sortType: "map",
        operators: [
            { title: "filenames contain...", value: "filenames contain...", valueInput: { type: 'ImageInput', col: 2, information: { required: true, placeholder: "Upload" } } },
            { title: "has file type...", value: "has file type...", valueInput: { type: 'ImageInput', col: 2, information: { required: true, placeholder: "Upload" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Map' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },
    FilterEditor: {
        label: '{{lang}}Filter editor',
        type: 'FilterEditor',
        icon: '/assets/icons/forms/filter.svg',
        parent: 'main',
        sortType: "filter",
        hideInFormBuilder: true,
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Filter' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}choose Filter...' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },
    UnicIdInput: {
        label: '{{lang}}Unique Id',
        type: 'UnicIdInput',
        icon: '/assets/icons/forms/uniqueId.svg',
        parent: 'main',
        sortType: "unicid",
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Id' } },
            { type: 'TextInput', key: 'placeholder', information: { label: '{{lang}}Place Holder', defaultValue: '{{lang}}Enter an Id' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'TextInput', key: 'id', information: { label: '{{lang}}Id', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },




    JsonInput: {
        label: '{{lang}}Json',
        type: 'JsonInput',
        icon: '/assets/icons/applets/database/user.svg',
        parent: 'main',
        sortType: 'number',
        hideInFormBuilder: true,

        operators: [
            { title: "is", value: "==", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is not", value: "is not", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is any of", value: "is any of", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is none of", value: "is none of", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Assigned User' } },
            // { type: 'GlobalUserInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
            // { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

        ]
    },



    GlobalUserInput: {
        label: '{{lang}}User',
        type: 'GlobalUserInput',
        icon: '/assets/icons/applets/database/user.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "is", value: "==", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is not", value: "is not", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is any of", value: "is any of", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is none of", value: "is none of", valueInput: { type: 'GlobalUserInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Assigned User' } },
            // { type: 'GlobalUserInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
            // { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

        ]
    },


    InvoiceInput: {
        label: '{{lang}}Invoice',
        type: 'InvoiceInput',
        icon: '/assets/icons/forms/invoice.svg',
        parent: 'advanced',
        sortType: "invoice",
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },

    EditorInput: {
        label: '{{lang}}Text Editor',
        type: 'EditorInput',
        icon: '/assets/icons/forms/editor.svg',
        parent: 'main',
        sortType: "propfileimagerow",
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'NumberInput', key: 'QUANTITY', information: { label: '{{lang}}QUANTITY', defaultValue: '1.00' } },
            { type: 'NumberInput', key: 'RATE', information: { label: '{{lang}}RATE', defaultValue: '0.00' } },
            { type: 'SelectInput', key: 'TAX', information: { label: '{{lang}}TAX', defaultValue: '{{lang}}Select Tax' } },
            { type: 'NumberInput', key: 'AMOUNT', information: { label: '{{lang}}AMOUNT', defaultValue: '0.00' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },
    EditorInputNew: {
        label: '{{lang}}New text editor',
        type: 'EditorInputNew',
        icon: '/assets/icons/forms/editor.svg',
        parent: 'main',
        sortType: "propfileimagerow",
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },




    // TO DO
    CalendarInput: {
        label: '{{lang}}Calendar',
        type: 'CalendarInput',
        icon: '/assets/icons/forms/calendar.svg',
        parent: 'main',
        sortType: "propfileimagerow",
        hideInFormBuilder: true,

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'NumberInput', key: 'start', information: { label: '{{lang}}Start', defaultValue: '1Feb' } },
            { type: 'NumberInput', key: 'end', information: { label: '{{lang}}End', defaultValue: '17Feb' } },
            { type: 'SelectInput', key: 'Week Start On', information: { label: '{{lang}}Week Start On', defaultValue: 'Sunday' } },
            { type: 'SelectInput', key: 'Allowed Days', information: { label: '{{lang}}Allowed Days', defaultValue: 'Monday' } },
            { type: 'SelectInput', key: 'Allowed Dates', information: { label: '{{lang}}Allowed Dates', defaultValue: 'Past dates' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },


    // TO DO
    WorkingHoursInput: {
        label: '{{lang}}Working hours',
        type: 'WorkingHoursInput',
        icon: '/assets/icons/forms/working.svg',
        parent: 'main',
        sortType: "workingHours",
        hideInFormBuilder: true,
        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'NumberInput', key: 'start', information: { label: '{{lang}}Start', defaultValue: '1Feb' } },
            { type: 'NumberInput', key: 'end', information: { label: '{{lang}}End', defaultValue: '17Feb' } },
            { type: 'SelectInput', key: 'Week Start On', information: { label: '{{lang}}Week Start On', defaultValue: 'Sunday' } },
            { type: 'SelectInput', key: 'Allowed Days', information: { label: '{{lang}}Allowed Days', defaultValue: 'Monday' } },
            { type: 'SelectInput', key: 'Allowed Dates', information: { label: '{{lang}}Allowed Dates', defaultValue: 'Past dates' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },


    // TO DO
    CheckBoxListInput: {
        label: '{{lang}}Checkbox list',
        type: 'CheckBoxListInput',
        icon: '/assets/icons/forms/checklist.svg',
        parent: 'main',
        sortType: "CheckBoxList",
        hideInFormBuilder: true,

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },


    // TO DO
    AvailabilityTimeInput: {
        label: '{{lang}}Available Times',
        type: 'AvailabilityTimeInput',
        icon: '/assets/icons/forms/availble.svg',
        parent: 'main',
        sortType: "availabilitytime",
        hideInFormBuilder: true,

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}File' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },
    // StatusSelectInput: {
    //     label: 'Status',
    //     type: 'StatusSelectInput',
    //     icon: '/assets/icons/calendar.png',
    //     parent: 'main',
    //     sortType: "status",
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { required: true, label: 'Field Label', defaultValue: 'File' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'NumberInput', key: 'start', information: { label: 'Start', defaultValue: '1Feb' } },
    //         { type: 'NumberInput', key: 'end', information: { label: 'End', defaultValue: '17Feb' } },
    //         { type: 'SelectInput', key: 'Week Start On', information: { label: 'Week Start On', defaultValue: 'Sunday' } },
    //         { type: 'SelectInput', key: 'Allowed Days', information: { label: 'Allowed Days', defaultValue: 'Monday' } },
    //         { type: 'SelectInput', key: 'Allowed Dates', information: { label: 'Allowed Dates', defaultValue: 'Past dates' } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },

    // GlobalUserInput: {
    //     label: 'Globaluser',
    //     type: 'GlobalUserInput',
    //     icon: '/assets/icons/robot.png',
    //     parent: 'main',
    //     sortType: "globaluser",
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { required: true, label: 'Field Label', defaultValue: 'Id' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: 'Enter an Id' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },
    // ColorInput: {
    //     label: 'Color',
    //     type: 'ColorInput',
    //     icon: '/images/creatnots.png',
    //     parent: 'main',
    //     sortType: "color",
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { required: true, label: 'Field Label', defaultValue: 'Id' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: 'Enter an Id' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },





    // editorInput: {
    //     label: 'Html Editor',
    //     type: 'editorInput',
    //     icon: 'https://image.flaticon.com/icons/svg/1647/1647284.svg',
    //     notInSubform: true,
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: 'Field Label', defaultValue: 'Html Editor' } },
    //         { type: 'TextInput', key: 'defaultValue', information: { label: 'Default Value', defaultValue: '' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },


    // SelectInput: {
    //     label: 'Dropdown',
    //     type: 'selectInput',
    //     icon: 'https://image.flaticon.com/icons/svg/1057/1057094.svg',
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: 'Field Label', defaultValue: 'Dropdown' } },
    //         { type: 'optionMakerInput', key: 'options', information: { label: 'Options', options: [], type: 'radio' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: 'انتخاب کنید' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'searchable', information: { label: 'Searchable', defaultValue: true } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },


    // SelectApiInput: {
    //     label: 'Lookup List',
    //     type: 'selectApiInput',
    //     icon: 'https://image.flaticon.com/icons/svg/1057/1057666.svg',
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: 'Field Label', defaultValue: 'Lookup List' } },
    //         { type: 'TextInput', key: 'address', information: { label: 'Lookup From', defaultValue: '' } },
    //         { type: 'TextInput', key: 'titleField', information: { label: 'Title Field', defaultValue: '' } },
    //         // { type: 'TextInput', key: 'valueField', information: { label: 'Value Field', defaultValue: '' } },
    //         { type: 'TextInput', key: 'filter', information: { label: 'Filter', defaultValue: '' } },

    //         // { type: 'optionMakerInput', key: 'options', information: { label: 'Options', options: [], type: 'radio' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: 'انتخاب کنید' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'searchable', information: { label: 'Searchable', defaultValue: true } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },



    // TextRecommenderInput: {
    //     label: 'Text Recom.',
    //     type: 'textRecommenderInput',
    //     icon: 'https://image.flaticon.com/icons/svg/1057/1057666.svg',
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: 'Field Label', defaultValue: 'Text Recommender' } },
    //         { type: 'TextInput', key: 'address', information: { label: 'Lookup From', defaultValue: '' } },
    //         { type: 'TextInput', key: 'titleField', information: { label: 'Title Field', defaultValue: '' } },
    //         // { type: 'TextInput', key: 'valueField', information: { label: 'Value Field', defaultValue: '' } },
    //         { type: 'TextInput', key: 'filter', information: { label: 'Filter', defaultValue: '' } },

    //         // { type: 'optionMakerInput', key: 'options', information: { label: 'Options', options: [], type: 'radio' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: 'انتخاب کنید' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'searchable', information: { label: 'Searchable', defaultValue: true } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },






    SubformInput: {
        label: '{{lang}}Subform',
        type: 'SubformInput',
        icon: '/assets/icons/forms/subform.svg',
        parent: 'advanced',
        sortType: "subform",
        notInSubform: true,
        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Subform' } },
            // { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: '' } },
            // { type: 'TextInput', key: 'defaultValue', information: { label: 'Default Value', defaultValue: [] } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: '{{lang}}Required', defaultValue: false } },
            { type: 'SwitchInput', key: 'showMain', information: { label: '{{lang}}Show in table', defaultValue: true } },

        ]
    },

    GroupInput: {
        label: '{{lang}}Group',
        type: 'MultiTreeSelectAddListing',
        icon: '/assets/icons/forms/power.svg',
        parent: 'main',

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Field Label', defaultValue: '{{lang}}Group' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },

        ],
        hideInFormBuilder: true

    },



    StageInput: {
        label: '{{lang}}Stages',
        type: 'StageInput',
        icon: '/assets/icons/forms/subform.svg',
        parent: 'main',
        // sortType: "subform",

        operators: [
            { title: "{{lang}}is", value: "==", valueInput: { type: 'StagesSelectInput', col: 2, padding: '1px 2px', information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "{{lang}}is not", value: "is not", valueInput: { type: 'StagesSelectInput', col: 2, information: { required: true, placeholder: "{{lang}}Value ..." } } },
            { title: "{{lang}}is empty", value: "is empty", valueInput: { type: "EmptyInput" } },
            { title: "{{lang}}is not empty", value: "is not empty", valueInput: { type: "EmptyInput" } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Stages', defaultValue: '{{lang}}Stages', disabled: 'true' } },

        ],
        hideInFormBuilder: true
    },

    // TO DO
    AdvancedColorInput: {
        label: '{{lang}}Advanced Color Input',
        type: 'AdvancedColorInput',
        icon: '/assets/icons/forms/subform.svg',
        parent: 'main',
        hideInFormBuilder: true,
        // sortType: "subform",
        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Stages', defaultValue: '{{lang}}Stages', disabled: 'true' } },

        ]
    },


    // TO DO
    ColorInput: {
        label: '{{lang}}Color Input',
        type: 'ColorInput',
        icon: '/assets/icons/forms/subform.svg',
        parent: 'main',
        // hideInFormBuilder: true,

        // sortType: "subform",
        headers: [
            { type: 'TextInput', key: 'label', information: { label: '{{lang}}Stages', defaultValue: '{{lang}}Stages', disabled: 'true' } },

        ]
    },





    HubConditionalFilterInput: {
        label: '{{lang}}User',
        type: 'GlobalUserInput',
        icon: '/assets/icons/applets/database/user.svg',
        parent: 'main',
        sortType: 'number',
        operators: [
            { title: "Has access to", value: "access", valueInput: { type: 'VariablesInput', padding: '1px 2px', col: 2, information: { required: true, placeholder: "", validTypes: ['stage', 'frame', 'applet'], } } },
            // { title: "Has access to", value: "access", valueInput: { type: 'VariablesInput', padding: '1px 2px', col: 2, information: { required: true, placeholder: "", validTypes: ['stage', 'frame', 'applet','permission'], } } },

            // { title: "Don't have access to", value: "noAccess", valueInput: { type: 'VariablesInput', col: 2, information: { required: true, placeholder: "" } } },
            { title: "Is in group", value: "inGroup", valueInput: { type: 'GroupsSelectInput', col: 2, information: { required: true, address: 'getConnectionGroups',filter: { hub: "{{appletHubId}}" }, fields: { title: 'name', parent: 'parent', licensed: 'licensed', value: '_id' },placeholder: "" } } },
            { title: "Is not in group", value: "notInGroup", valueInput: { type: 'GroupsSelectInput', col: 2, information: { required: true,address: 'getConnectionGroups', filter: { hub: "{{appletHubId}}" }, fields: { title: 'name', parent: 'parent', licensed: 'licensed', value: '_id' },placeholder: "" } } },
            { title: "Hub is", value: "hubIs", valueInput: { type: 'GlobalUserInput', padding: '1px 2px', col: 2, information: { required: true, showVariables: true, placeholder: "", validTypes: ['user'], } } },
            { title: "Hub is not", value: "hubIsNot", valueInput: { type: 'GlobalUserInput', padding: '1px 2px', col: 2, information: { required: true, showVariables: true, placeholder: "", validTypes: ['user'], } } },
        ],

        headers: [
            { type: 'TextInput', key: 'label', information: { required: true, label: '{{lang}}Field Label', defaultValue: '{{lang}}Assigned User' } },
            // { type: 'GlobalUserInput', key: 'defaultValue', information: { label: '{{lang}}Default Value', defaultValue: '' } },
            { type: 'TextInput', key: 'hint', information: { label: '{{lang}}Hint', defaultValue: '' } },
            { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
            // { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

        ]
    },



    // ProductInput: {
    //     label: 'Products',
    //     type: 'productInput',
    //     icon: 'https://image.flaticon.com/icons/svg/1057/1057666.svg',
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: 'Field Label', defaultValue: 'Lookup List' } },
    //         { type: 'TextInput', key: 'address', information: { label: 'Lookup From', defaultValue: '' } },
    //         { type: 'TextInput', key: 'titleField', information: { label: 'Title Field', defaultValue: '' } },
    //         // { type: 'TextInput', key: 'valueField', information: { label: 'Value Field', defaultValue: '' } },
    //         { type: 'TextInput', key: 'filter', information: { label: 'Filter', defaultValue: '' } },

    //         // { type: 'optionMakerInput', key: 'options', information: { label: 'Options', options: [], type: 'radio' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: 'انتخاب کنید' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'searchable', information: { label: 'Searchable', defaultValue: true } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },



    // PriceInput: {
    //     label: 'Price',
    //     type: 'priceInput',
    //     icon: 'https://image.flaticon.com/icons/svg/1647/1647300.svg',
    //     headers: [
    //         { type: 'TextInput', key: 'label', information: { label: 'Price', defaultValue: 'Price' } },
    //         { type: 'TextInput', key: 'placeholder', information: { label: 'Place Holder', defaultValue: '' } },
    //         { type: 'NumberInput', key: 'defaultValue', information: { label: 'Default Value', defaultValue: '' } },
    //         { type: 'TextInput', key: 'hint', information: { label: 'Hint', defaultValue: '' } },
    //         { type: 'SwitchInput', key: 'required', information: { label: 'Required', defaultValue: false } },
    //         { type: 'SwitchInput', key: 'showMain', information: { label: 'Show in table', defaultValue: true } },

    //     ]
    // },

    // TextInput2: { label: 'Multi Line', type: 'TextInput', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { label: 'Number', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Decimal', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Name', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Address', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Phone', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Email', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Date', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Time', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Drop Down', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Radio', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Multiple Choice', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Check box', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Decision Box', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Date - Time', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Website', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'Currency', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // TextCell1: { name: 'File Uplaod', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // ImageCell: { name: 'Image Upload', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },

    // { name: 'Section', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Page Break', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Payment', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Matrix Choice', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Lookup', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Terms and conditions', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Editor', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Formula', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Uniqe Id', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Slider', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Rating', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'File Manager', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },
    // { name: 'Signature', type: 'text', icon: 'https://image.flaticon.com/icons/svg/1102/1102457.svg' },

}

const FormBuilderItems = Object.values(FormBuilderObjects)
// console.log(FormBuilderItems)

export { FormBuilderItems, TypeToInputType, InputTypeToType, FormBuilderObjects, formBuilderGroups }